<template>
<div class="page_specail page_iteminfo">
    <!-- 背景图 -->
    <div class="bg_wrap">
        <img :src="imageUrl+specialDetail.background_img" alt="" class="bg_tu">
    </div>
    <!-- 内容区 -->
    <div class="list">
        <!-- 循环体 -->
        <div class="item" v-for="item in specialDetail.tradesman" :key="item.tradesman_id">
            <div class="item_t">
                <div class="title" @click="toTradesman(item.tradesman_id)">{{item.nickname}}</div>
                <div :class=" item.attention_status ? 'guanzhu guanzhu_ed' : 'guanzhu'" @click="attentionTradesmanFun(item)">{{item.attention_status==1?'已关注':'关注'}}</div>
            </div>
            <div class="desc" @click="toTradesman(item.tradesman_id)">
                <img :src="imageUrl+item.special_thumb" alt="" class="tu">
                <div class="content">{{ item.special_describe }}</div>
            </div>
            <div class="dingzhi" v-for="(customade,index) in item.customades" :key="index">
                <ul class="dingzhi_list clearfix" @click="goDingzhi(customade)">
                    <div class="dingzhi_left">
                        <van-image fit="cover" :src="imageUrl+customade.thumb" class="dingzhi_image" :show-error="false" :show-loading="false" />
                        <img class="dingzhi_right" :src="publicPath+'/statics/images/zt_dingzhi.png'"/>
                    </div>
                    <div class="dingzhi_content">
                        <div class="title">{{customade.title}}</div>
                        <div class="tip">已定制</div>
                        <van-progress :percentage="(customade.accept_order_count==0?0:customade.order_count+customade.false_data)/customade.accept_order_count*100" :pivot-text="customade.order_count+'件'"  color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
                        <div class="tip" >{{ customade.timeLeft ? '剩余时长：' : '截止日期：'}}<span class="nums">{{ customade.timeLeft ? customade.timeLeft :customade.end_at }}</span></div>
                    </div>
                </ul>
            </div>
            <div class="goods_wrap">
                <van-swipe :loop="false">
                    <van-swipe-item v-for="(goodsList,index) in item.data" :key="index">
                        <ul class="goods_list clearfix">
                            <li class="goods_item f-l"  v-for="goods in goodsList" :key="goods.id" @click="goDetail(goods)">
                                <div class="goods_tu">
                                    <img :src="imageUrl+goods.thumb" alt="" class="" />
                                    <img class="goods_yuekan" v-if="goods.type&&goods.type==2" :src="publicPath+'/statics/images/zt_yuekan.png'"/>
                                </div>
                                <div class="goods_name slh_s">{{ goods.title }}</div>
                                <div class="goods_price">¥{{goods.price}}</div>
                            </li>
                        </ul>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SETTLE
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    // name: "map-index",
    data() {
        return {
            specialId: this.$route.query.specialId,
            publicPath: process.env.BASE_URL,
            imageUrl: this.$publicData.uploadImage,
			specialDetail: {},
			shareConfig: null, // 分享的相关配置
			token: null
        };
    },
    components: {
        // PageSearch
    },
    created: function () {
        // this.$store.commit(LOGIN, {
        //     token: 'PcXDUJmXARBSUuN9KBl74Q==',
        // });
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        var that = this
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    naviTitle: "专题",
                    'rightStyle': 'share'
                },
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    }
                    this.getSpecialDetailData();
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback("");
                }
            );
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.specialDetail.title,
                        detail: that.specialDetail.describe,
                        url: url,
                        platFormType:'',
                        image: that.$publicData.domain + that.specialDetail.thumb
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
            // 获取商品详情
            this.getSpecialDetailData();
        }
    },
    methods: {
        // 获取商品详情
        getSpecialDetailData() {
            var params = {
                token: this.token,
                special_id: this.specialId,
            };
            this.$api.shop.specialDetail(params).then((res) => {
                if (res.code == 200) {
					
                    var data = res.result
                    if (data.tradesman) {
                        for(var i = 0 ; i < data.tradesman.length ; i++){
                            var goods = data.tradesman[i].data
                            var newArr = []
                            for(var j = 0; j< goods.length; j+=3){
                                newArr.push(goods.slice(j, j + 3))
                            }
                            data.tradesman[i].data = newArr
                        }
                    }
					
					console.log('data ----', data)
                    this.specialDetail = data
                    console.log('data2 ----', data)
                    this.setNaviStyle()
					// 分享
					this.getShareData()
                } else {
                    this.$toast(res.message);
				}
				
            });
        },
        setNaviStyle() {
            console.log('this.specialDetail.title:',this.specialDetail.title)
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                console.log('this.specialDetail.title222:',this.specialDetail.title)
                    var params = {
                        data: {
                            naviTitle: this.specialDetail.title,
                            'rightStyle': 'share'
                        },
                    };
                    this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            } else {
                window.document.title = this.specialDetail.title
            }
        },
		// 关注匠人 对APP和H5进行判断
		attentionTradesmanFun(item){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionTradesman(item)
						}
					}
				);
			} else {
				this.attentionTradesman(item)
			}
		},
        attentionTradesman(item) {
            var type = 1
            if (item.attention_status == 1) {
                type = 2
            }
            var params = {
                token: this.token,
                tradesman_id: item.tradesman_id,
                type: type
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res=>{
                if(res.code == 200){
                    if (item.attention_status == 1) {
                        this.$toast('取消关注成功')
                    } else {
                        this.$toast('关注成功')
                    }
                    this.getSpecialDetailData();
                } else {
                    this.$toast(res.message)
                }
            })
		},
        goDingzhi(item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                url = this.$publicData.clientUrl + '/dingzhi/detail?id=' + item.id
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/detail',
                    query: {
                        id: item.id
                    }
                })
            }
        },
		// 专题详情
		goDetail(goods){
			console.log('goods',goods)
			if(goods.type == 1){
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var p = "?goodsId=" + goods.id
                    var params = {
                        'data': {
                            'url': this.$publicData.clientUrl + '/shop/detail' + p
                        }
                    }
                    this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                    })
                } else {
                    this.$router.push({
                        path: '/shop/detail',
                        query: {
                            goodsId: goods.id
                        }
                    })
                }
				// 商品详情
				// this.$router.push({
				// 	path: '/shop/detail',
				// 	query: {
				// 		goodsId: goods.id
				// 	}
				// })
				
			}else if(goods.type == 2){
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var params = {
                        'data': {
                            'url': this.$publicData.clientUrl + '/yuekan/detail?id=' + goods.id
                        }
                    }
                    this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                    })
                } else {
                    this.$router.push({
                        path: '/yuekan/detail',
                        query: {
                            id: goods.id
                        }
                    })
                }
				// 约看详情
				// this.$router.push({
				// 	path: '/yuekan/detail',
				// 	query: {
				// 		id: goods.id
				// 	}
				// })
			}
		},
		// 匠人详情
		toTradesman(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url:
                            this.$publicData.clientUrl +
                            "/art/detail?tradesmanId=" +
                            id,
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/art/detail",
                    query: {
                        tradesmanId: id,
                    },
                });
            }
        },
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
        shareFun() {
			var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: that.specialDetail.title, // 分享标题
					desc: that.specialDetail.describe, // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.$publicData.imageUrl + that.specialDetail.thumb, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
